export const UI_VISIBILITY_ROLES: { id: string; label: string }[] = [
  { id: 'author', label: 'Standard' },
  { id: 'editor', label: 'Advanced' },
];

/**
 * OJS lines the "OJS XML" export can target, newest first (newest reads as the default choice).
 *
 * OJS native XML is ONE export whose target release is a parameter, not one export per version:
 * the file goes to the same kind of consumer either way, so a version does not earn its own
 * export button.
 *
 * Mirrors `OJS_VERSIONS` in `@sciflow/export` (libs/export/src/xml/ojs.tsx), which is the real
 * source of truth: the download route validates `?ojsVersion=` against it. It is duplicated here
 * rather than imported because `@sciflow/export` is a Node-side library (jsdom, xmlbuilder2) that
 * must not be pulled into the browser bundle. Keep the two lists in step when adding a line — a
 * value listed here but unknown there is ignored by the route, which then falls back to the
 * template's `kind: Ojs` version, so the failure is a silently older export rather than an error.
 */
export const OJS_EXPORT_VERSIONS: { id: string; label: string }[] = [
  { id: '3.6', label: 'OJS 3.6' },
  { id: '3.5', label: 'OJS 3.5' },
  { id: '3.4', label: 'OJS 3.4' },
];

/**
 * Pre-selected when the template pins no `kind: Ojs` version. Deliberately 3.5, matching
 * `DEFAULT_OJS_VERSION` in `@sciflow/export`: 3.5 is PKP's LTS line and what an OJS install is
 * most likely running, so adding 3.6 as a CHOICE must not quietly re-target existing exports.
 */
export const DEFAULT_OJS_EXPORT_VERSION = '3.5';
